// MessageAttachments.jsx
import React from "react";

// 判斷檔案類型（圖片 / PDF / 文字 / 其他）
const getFileKind = (file) => {
  const name = file.file_name?.toLowerCase() || "";
  const type = file.file_type?.toLowerCase() || "";
  console.log('file:',file)
  console.log('type:',type)

  const isImage =
    type.startsWith("image/") ||
    [".png", ".jpg", ".jpeg", ".gif", ".webp"].some((ext) =>
      name.endsWith(ext)
    );

  const isPdf =
    type === "application/pdf" || name.endsWith(".pdf");

  const isText =
    type.startsWith("text/") ||
    [".txt", ".md", ".log"].some((ext) => name.endsWith(ext));

  return { isImage, isPdf, isText };
};

const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  const mb = kb / 1024;
  if (mb < 1024) return `${mb.toFixed(1)} MB`;
  const gb = mb / 1024;
  return `${gb.toFixed(1)} GB`;
};

const MessageAttachments = ({ files }) => {
  if (!files || files.length === 0) return null;

  return (
    <div className="message-attachments">
      {files.map((file) => {
        const { isImage, isPdf, isText } = getFileKind(file);
        const sizeLabel = formatFileSize(file.file_size);

        return (
          <a
            key={file.id}
            href={file.file_url}
            target="_blank"
            rel="noopener noreferrer"
            className="attachment-item"
          >
            <div className="attachment-thumb">
              {isImage ? (
                <img
                  src={file.file_url}
                  alt={file.file_name}
                  className="attachment-image"
                  onError={(e) => {
                    // 圖片壞掉時改用 icon
                    e.target.style.display = "none";
                    e.target.parentElement.classList.add(
                      "attachment-thumb-fallback"
                    );
                  }}
                />
              ) : isPdf ? (
                <span className="attachment-icon">📄</span>
              ) : isText ? (
                <span className="attachment-icon">📃</span>
              ) : (
                <span className="attachment-icon">📎</span>
              )}
            </div>

            <div className="attachment-info">
              <div className="attachment-name" title={file.file_name}>
                {file.file_name}
              </div>
              {sizeLabel && (
                <div className="attachment-meta">{sizeLabel}</div>
              )}
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default MessageAttachments;
